import { ProductListingToPayoutRule } from "../../../../../../common/models";
import { ColumnConfig } from "../../../../common/tables/config/ColumnConfig";
import { EnumResolver } from "../../../../common/tables/etc/EnumResolver";
import { TableCellFactory } from "../../../../common/tables/factory";
import { PLPRTableRow } from "../../../../../../common/tables/product-listing/payout-rule-mapping/PLPRTableRow";
import { PLPREnumMapper } from "../etc/PLPREnumMapper";

export class PLPRTableCellFactory extends TableCellFactory<PLPRTableRow, ProductListingToPayoutRule> {
    readonly enumResolver: EnumResolver<PLPRTableRow> = new PLPREnumMapper();

    protected resolveCellData(
        columnConfig: ColumnConfig<PLPRTableRow>,
        rowData: ProductListingToPayoutRule,
    ): string {
        const colName = columnConfig.columnName as string;

        if (colName === "payoutRuleName") {
            return rowData.payoutRule?.name ?? "";
        }

        if (colName === "payoutRuleType") {
            return rowData.payoutRule?.type ?? "";
        }

        if (colName === "costPayoutModifierName") {
            return rowData.costPayoutModifier?.name ?? "Default";
        }

        return super.resolveCellData(columnConfig, rowData);
    }
}
